import { P2GGrid } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { ServiceSpeedTypeOptions, ServiceTagTypeOptions } from '../utils/PopulateQuoteTags';
import SidePanelSection from '../../../../../../components/sidepanel-section';
import { GetColumnHeading } from '../utils/GetColumnHeading';
import { PanelButtons } from '../../panels/PanelButtons';
import { P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { ConfigSetting, useTenant } from '@parcel2go/npm-p2g-app';

interface props {
  setTags: (tags: string[]) => void;
  selected: string[];
  setMatchAllTags: (val: boolean) => void;
  matchAllTags: boolean;
  close?: () => void;
  isXs: boolean;
  children?: React.ReactNode;
}

interface GroupingProps {
  title: string;
  tags: { text: string; value: string }[];
  select: (t: string) => void;
  selected: (t: string) => boolean;
  xs?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  sm?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

const Grouping: React.FC<GroupingProps> = (props) =>
  props.tags.length == 0 ? null : (
    <P2GGrid item>
      <SidePanelSection title={props.title}>
        <P2GGrid container direction="column">
          {props.tags.map((t) => (
            <P2GGrid item key={t.value}>
              <P2GCheckBoxLegacy
                onChange={() => props.select(t.value)}
                id={t.value}
                key={t.value}
                checked={props.selected(t.value)}
                label={<P2GText variant="body2">{t.text || t.value}</P2GText>}
                labelPlacement="end"
                variant="primary"
                error={false}
              />
            </P2GGrid>
          ))}
        </P2GGrid>
      </SidePanelSection>
    </P2GGrid>
  );

export const QuoteTagFilter: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const { settings } = useTenant();

  const toggleFilterTag = (tag: string) =>
    props.setTags(props.selected.includes(tag) ? props.selected.filter((t) => t != tag) : [...props.selected, tag]);

  const clear = () => props.setTags([]);

  return (
    <P2GGrid container spacing={5}>
      <P2GGrid item>
        <P2GGrid container spacing={2} direction="column">
          <Grouping
            title={t('DELIVERY_TIME_SUBTITLE', { defaultValue: 'Delivery Time' })}
            select={(t) => toggleFilterTag(t)}
            selected={(t) => props.selected.includes(t)}
            tags={ServiceSpeedTypeOptions.map((x) => ({
              value: x,
              text: GetColumnHeading(
                x,
                '',
                settings[ConfigSetting.DEFAULT_ORIGIN_COUNTRY],
                settings[ConfigSetting.DEFAULT_DESTINATION_COUNTRY]
              )
            }))}
          />
          <Grouping
            title={t('SERVICE_TYPE_SUBTITLE', { defaultValue: 'Service Type' })}
            select={(t) => toggleFilterTag(t)}
            selected={(t) => props.selected.includes(t)}
            tags={ServiceTagTypeOptions.filter((x) => x == 'Signed For' || x == 'Special Delivery').map((x) => ({
              value: x,
              text: x
            }))}
          />
          <Grouping
            title={t('PACKAGE_TYPE_SUBTITLE', { defaultValue: 'Package Type' })}
            select={(t) => toggleFilterTag(t)}
            selected={(t) => props.selected.includes(t)}
            tags={ServiceTagTypeOptions.filter(
              (x) => x == 'Large Letter' || x == 'Parcel' || x == 'Standard Letter'
            ).map((x) => ({ value: x, text: x }))}
          />
        </P2GGrid>
      </P2GGrid>
      {props.children && <P2GGrid item>{props.children}</P2GGrid>}
      <P2GGrid item xs={12}>
        {/* <P2GCheckBoxLegacy
            onChange={props.setMatchAllTags}
            id="Match All"
            checked={props.matchAllTags}
            label={<P2GText>Only show services which match all my selections.</P2GText>}
          /> */}
        {props.close && (
          <PanelButtons
            onSave={props.close}
            saveText={
              props.isXs
                ? t('APPLY_BUTTON', { defaultValue: 'Apply' })
                : t('VIEW_SERVICES_BUTTON', { defaultValue: 'View Services' })
            }
            onCancel={clear}
            cancelText={
              props.isXs
                ? t('CLEAR_BUTTON', { defaultValue: 'Clear' })
                : t('CLEAR_SELECTION_BUTTON', { defaultValue: 'Clear Selection' })
            }
            cancelDisabled={props.selected.length === 0}
          />
        )}
      </P2GGrid>
    </P2GGrid>
  );
};
